<template>
  <div class="codeManger">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">

        <el-input v-if="radio == '条件查询'" placeholder="SN码，服务商" v-model="searchStr" size="medium" style="width: 310px"
          class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>

        </el-input>
        <el-checkbox v-model="mhYn">模糊</el-checkbox>
        <el-checkbox v-model="zcYn">非正常</el-checkbox>
      </div>
      <div class="x-flex">
        <el-button v-if="showXz" type="" size="medium" @click="fRegWxUser('新增')">新增</el-button>
        <el-button v-if="showHb" type="" size="medium" @click="fRegWxUser('批量划拨')">批量划拨</el-button>
        <!-- <el-button v-if="showXg" type="" size="medium" @click="fRegWxUser('批量修改')">批量修改</el-button> -->
        <el-button v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'" type="" size="medium"
          @click="fRegWxUser('批量删除')">批量删除</el-button>
        <el-button v-if="showXz" type="primary" size="medium" @click="fRegWxUser('批量新增')">批量新增</el-button>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table ref="codeMangerTable" border resizable highlight-hover-row height="100%" :data="tableData"
          :checkbox-config="{ reserve: true }" align="center">
          <!-- :sort-config="{remote:true}" @sort-change='fSort' -->
          <vxe-column type="checkbox" fixed="left" width="60"></vxe-column>
          <vxe-column field="RC" title="序号" width="80" fixed="left" sortable></vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :min-width="item.width" v-for="item in tableJson"
            sortable :key="item.id">
          </vxe-column>
          <vxe-column fixed="right" title="操作" width="80" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <div class="x-flex x-row-around">
                <el-button type="text" size="mini" @click="fModify(scope.row)" class="" style="color: #2c8ff2">
                  修改
                </el-button>
                <el-button v-if="scope.row.state != '删除' && showSc" type="text" size="mini"
                  @click="fDel('DEL',[scope.row.sn_id])" class="" style="color: #2c8ff2">
                  删除
                </el-button>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
          :page-size="50" :current-page="nowPage" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="addOrEditPop" width="600px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">
          <!-- {{ codeMangerAddOrEdit == "PLADD" ? "批量生成" : "修改商户" }} -->
          {{codeMangerAddOrEdit}}
        </div>
        <div style="cursor: pointer;" @click="fClose()">
          X
        </div>
      </div>
      <!-- 机构编号  AI编码-->
      <el-row>
        <el-col :span="24" class="x-flex x-p-t-20"
          v-if="this.codeMangerAddOrEdit == '批量划拨' || this.codeMangerAddOrEdit == '批量修改' ">
          <div class="x-w100 x-text-r x-p-r-10">SN码</div>
          <span v-for="(item ,index) in sn_arr" :key='index' class="x-p-l-4"> {{index>0?';':''}}{{item}}</span>
        </el-col>
        <el-col :span="24" class="x-flex x-p-t-20" v-else>
          <div class="x-w100 x-text-r x-p-r-10">SN码</div>
          <el-input class="x-flex-1" v-model="snCodeInfo.sn_id" :disabled="this.codeMangerAddOrEdit == '修改'"
            :placeholder="this.codeMangerAddOrEdit == '批量新增'?'多个SN号使用英文分号 ; 隔开':''"></el-input>
        </el-col>

        <el-col :span="24" class="x-flex x-p-t-20">
          <div class="x-w100 x-text-r x-p-r-10">设备类型</div>
          <el-select v-model="snCodeInfo.device_type" placeholder="请选择" class="x-flex-1" size="medium" :disabled="true">
            <el-option v-for="item in deviceTypeOption" :key="item.val" :label="item.lable" :value="item.val">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="24" class="x-flex x-p-t-20">
          <div class="x-w100 x-text-r x-p-r-10">SAAS服务商</div>
          <el-input class="x-flex-2 " v-model="snCodeInfo.saas_org_id" placeholder="客户自助注册时所属服务商机构号"></el-input>
          <el-input class="x-flex-3 x-p-l-10" v-if="this.codeMangerAddOrEdit == '修改'" disabled
            v-model="snCodeInfo.saas_org_name"></el-input>
        </el-col>

        <el-col :span="24" class="x-flex x-p-t-20">
          <div class="x-w100 x-text-r x-p-r-10">支付服务商</div>
          <el-input class="x-flex-2 " v-model="snCodeInfo.pay_org_id" placeholder="客户自助进件时所属服务商机构号"></el-input>
          <el-input class="x-flex-3 x-p-l-10" v-if="this.codeMangerAddOrEdit == '修改'" disabled
            v-model="snCodeInfo.pay_org_name"></el-input>
        </el-col>
        <el-col :span="24" class="x-flex x-p-t-20">
          <div class="x-w100 x-text-r x-p-r-10">开户费率</div>
          <el-input class="x-flex-2 " v-model="snCodeInfo.pay_mch_rate" type="number"></el-input>
        </el-col>
        <el-col :span="24" class="x-flex x-p-t-20">
          <div class="x-w100 x-text-r x-p-r-10">业务员</div>
          <el-input class="x-flex-1" v-model="snCodeInfo.bus_org_user"></el-input>
        </el-col>
        <el-col :span="24" class="x-flex x-p-t-20">
          <div class="x-w100 x-text-r x-p-r-10">软件名称</div>
          <el-select v-model="snCodeInfo.band_saas_type" placeholder="请选择" class="x-flex-1" size="medium">
            <el-option v-for="item in rjTypeOption" :key="item.val" :label="item.lable" :value="item.val">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="24" class="x-flex x-p-t-20" v-if='zcYn && this.codeMangerAddOrEdit == "修改"'>
          <div class="x-w100 x-text-r x-p-r-10">状态</div>
          <el-select v-model="snCodeInfo.state" placeholder="请选择" class="x-flex-1" size="medium">
            <el-option v-for="item in stateOption" :key="item.label" :label="item.lable" :value="item.label">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="24" class="x-flex x-p-t-20">
          <div class="x-w100 x-text-r x-p-r-10">备注</div>
          <el-input class="x-flex-1" v-model="snCodeInfo.remarks"></el-input>
        </el-col>
      </el-row>
      <div class="x-flex x-row-right x-p-t-30">
        <el-button type="info" size="small" v-if="codeMangerAddOrEdit == '修改'"
          @click="fDel('DEL',[snCodeInfo.sn_id])">删除</el-button>
        <el-button type="info" size="small" v-else @click="fClose">关闭</el-button>
        <el-button type="primary" size="small" @click="fSavecodeManger">保存</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        sn_arr: [],
        zcYn: false,
        showXz: false,
        showXg: false,
        showHb: false,
        showSc: false,
        radio: "条件查询",
        searchStr: "",
        // uploadImgValue:'',//上传的文件名称
        mhYn: true, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        state: '全部',
        orgListSub: [],
        deviceTypeOption: [{
          lable: '尚米安卓一体机',
          val: '尚米安卓一体机'
        }],
        rjTypeOption: [{
          lable: '尚米零售5.0',
          val: '尚米零售5.0'
        }, {
          lable: '尚米云餐饮',
          val: '尚米云餐饮'
        }],
        tableJson: [{
            title: "状态",
            width: "80",
            sortType: "state",
          },
          {
            title: "SN码",
            width: "160",
            sortType: "sn_id",
          },
          {
            title: "设备类型",
            width: "170",
            sortType: "device_type",
          }, {

            title: "SAAS服务商",
            width: "160",
            sortType: "saas_org_id",
          }, {

            title: "支付服务商",
            width: "160",
            sortType: "pay_org_id",
          },
          {
            title: "开户费率",
            width: "120",
            sortType: "pay_mch_rate",
          },
          {
            title: "业务员",
            width: "160",
            sortType: "bus_org_user",
          },
          // {
          //   title: "绑定时间",
          //   width: "200",
          //   sortType: "",
          // },
          {
            title: "SAAS程序类型",
            width: "200",
            sortType: "band_saas_type",
          },

          {
            title: "修改时间",
            width: "180",
            sortType: "chg_time",
          },

        ],
        addOrEditPop: false, // 增加/修改用户
        codeMangerAddOrEdit: "批量新增",
        snCodeInfo: {
          sn_id: '',
          device_type: '尚米安卓一体机',
          saas_org_id: this.bykApi.global.fGetPlatform().partnerInfo.phone,
          mch_org_id: '',
          bus_org_user: '',
          pay_mch_rate: '3.8',
          band_saas_type: '尚米零售5.0',
          state: '未使用'
        },
        stateOption: [{
            label: '未使用'
          },
          // {
          //   label: '已绑定'
          // },
          {
            label: '删除'
          },
        ],

      };
    },
    watch: {
      zcYn() {
        this.nowPage = 1
        this.init();
      }
    },
    async created() {
      this.showXz = await this.bykApi.global.fGetSmMenuQx('设备SN新增')
      this.showXg = await this.bykApi.global.fGetSmMenuQx('设备SN修改')
      this.showHb = await this.bykApi.global.fGetSmMenuQx('设备SN划拨')
      this.showSc = await this.bykApi.global.fGetSmMenuQx('设备SN删除')
      this.init();
    },
    methods: {
      async init(orderBy) {
        let res = await this.GET_DEVICE_SN_INFO('SN_LIST', orderBy);

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.tableData = res.data;
        this.TR = res.page.TR
        this.TP = res.page.TP
      },

      async fModify(row) {
        this.codeMangerAddOrEdit = "修改";
        this.addOrEditPop = true;
        this.snCodeInfo = row;

      },
      async fSavecodeManger() {
        if (this.bykApi.smCom.fSmIsEmpty(this.snCodeInfo.sn_id) && (this.codeMangerAddOrEdit != '批量修改' && this
            .codeMangerAddOrEdit != '批量划拨')) {
          return this.$message("请输入SN号");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.snCodeInfo.saas_org_id)) {
          return this.$message("请输入SAAS服务商");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.snCodeInfo.pay_org_id)) {
          return this.$message("请输入支付服务商");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.snCodeInfo.pay_mch_rate)) {
          return this.$message("请输入开户费率");
        }
        // if (Number(this.snCodeInfo.pay_mch_rate) < 0 || Number(this.snCodeInfo.pay_mch_rate) > 100) {
        //   return this.$message("请正确的开户费率");
        // }

        // if (this.bykApi.smCom.fSmIsEmpty(this.snCodeInfo.bus_org_user)) {
        //   return this.$message("请输入业务员");
        // }
        if (this.snCodeInfo.state == '删除') {
          return this.$message("删除状态不允许修改");
        }
        // return
        let res;
        //激活
        let oper = ''
        switch (this.codeMangerAddOrEdit) {
          case '批量新增':
            oper = 'ADD'
            break
          case '批量修改':
            oper = 'EDIT'
            break
          case '修改':
            oper = 'EDIT'
            break
          case '新增':
            oper = 'ADD'
            break
          case '批量划拨':
            oper = 'CHG_ORG'
            break
        }
        let arr = this.snCodeInfo.sn_id.split(';')
        if (oper == 'CHG_ORG') {
          res = await this.DEVICE_SN_INFO(oper, this.sn_arr);
        } else {
          res = await this.DEVICE_SN_INFO(oper, arr);
        }

        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.fClose();
      },
      fDel(oper, code) {

        if (!this.showSc) {
          return this.$message("没有设备SN删除的权限");
        }
        console.log(code)
        this.$confirm('是否确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.DEVICE_SN_INFO(oper, code);
          this.$message(res.msg)
          if (res.result != 'sucess') {
            return
          }

          this.fClose();
        }).catch(() => {});

      },
      fClose() {
        this.addOrEditPop = false;
        this.snCodeInfo = Object.assign({
          sn_id: '',
          device_type: '尚米安卓一体机',
          saas_org_id: this.bykApi.global.fGetPlatform().partnerInfo.phone,
          mch_org_id: '',
          bus_org_user: '',
          band_saas_type: '尚米零售5.0',
          pay_mch_rate: '3.8',
          state: '未使用'
        });
        this.init();
      },
      // 排序
      fSort(e) {
        if (e.order == 'desc') {
          this.init(e.property + ' desc')
          return
        }
        this.init(e.property)
      },

      fHeadRadioChange(e) {},
      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fRegWxUser(type, item) {
        let arr = []
        if (type == '批量修改' || type == '批量划拨' || type == '批量删除') {
          let res = this.$refs.codeMangerTable.getCheckboxRecords(true)
          if (res.length < 1) {
            return this.$message('请勾选要操作的商品')
          }
          res.forEach(item => {
            arr.push(item.sn_id)
          })
          this.sn_arr = arr
        }
        if (type == '批量删除') {
          this.fDel('DEL', arr)
          return
        }
        if (!this.bykApi.smCom.fSmIsEmpty(item)) {
          this.snCodeInfo = item;
        }
        this.codeMangerAddOrEdit = type
        this.addOrEditPop = true;
      },
      // 分页
      async fCurrentChange(e) {
        this.nowPage = e
        let res = await this.GET_DEVICE_SN_INFO('SN_LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },
      // ------------- 请求 开始 --------------

      async GET_DEVICE_SN_INFO(oper) {
        let js = {};
        js['OPER'] = oper //'BACH_ADD'//
        js['DEVICE_TYPE'] = '尚米安卓一体机'
        js['ZC_YN'] = this.zcYn ? 'N' : 'Y'
        js['QRY_TXT'] = this.searchStr
        js['LIKE_YN'] = this.mhYn ? 'Y' : 'N'
        js['ORG_ID'] = this.bykApi.global.fGetPlatform().partnerInfo.phone
        js["PAGE_SIZE"] = 50;
        js["NOW_PAGE"] = '1';
        let res = await this.bykApi.newSmApi.fPostToSmSellMainQueryApi({
          sMethodName: 'GET_DEVICE_SN_INFO',
          reqJson: js,
        });
        return res;
      },
      async DEVICE_SN_INFO(oper, arr) {
        let js = {};
        // 批量 CHG_ORG BACH_CHG_PRO_ORG
        js['OPER'] = oper //'BACH_ADD'//
        js['CHG_USER_NAME'] = this.bykApi.global.fGetPlatform().partnerInfo.data.user_name
        js['DEVICE_TYPE'] = this.snCodeInfo.device_type // 设备类型：尚米安卓一体机
        js['SAAS_ORG_ID'] = this.snCodeInfo.saas_org_id // SAAS服务商
        js['MCH_ORG_ID'] = this.snCodeInfo.mch_org_id // 来源服务商
        js['PAY_ORG_ID'] = this.snCodeInfo.pay_org_id // 支付机构
        js['PAY_MCH_RATE'] = this.snCodeInfo.pay_mch_rate
        js['REMARKS'] = this.snCodeInfo.remarks // 备注
        js['STATE'] = this.snCodeInfo.state // 状态
        js['SN_ARR'] = arr // SN号JSON数组  ["1111","2222"]
        js['SN_ID'] = this.snCodeInfo.sn_id //
        js['BUS_ORG_USER'] = this.snCodeInfo.bus_org_user // 业务员
        js['BAND_SAAS_TYPE'] = this.snCodeInfo.band_saas_type // 绑定SAAS程序类型

        console.log(js)
        let res = await this.bykApi.newSmApi.fPostToSmSellMainAdminApi({
          sMethodName: 'DEVICE_SN_INFO',
          reqJson: js,
        });
        console.log(res)
        return res;
      },




      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .codeManger {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 1px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: -2px;

      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }

  /* .x-w66{} */
  .must1 {
    position: relative;
  }

  .must1:after {
    position: absolute;
    top: -4px;
    right: 2px;
    content: '*';
    color: red;
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/view/snCode.vue